import { Plugin } from 'prosemirror-state';

import { AddMenuNumbered, NumberList } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.ordered_list.title') as string,
            description: t('Lygo:Menu.ordered_list.description') as string,
            icon: NumberList,
            addMenuIcon: AddMenuNumbered,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['text', 'list', 'numbered list', 'basic', 'ordered list'],
            isText: true,
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
